import { React, useState, useEffect } from 'react';
import Nav from './nav';
import './tabs.css';
import Card from './card';
import Transcript from './bulletin';
import { Form, useNavigate } from 'react-router-dom';
import Receipt from './receipt.js';
import SearchDoc from './search.js';
import UploaDoc from './upload.js';

function Tab() {
  const [activeTab, setActiveTab] = useState('Tab1');
  const navigate = useNavigate();

  useEffect(() => {
    switch (activeTab) {
      case 'Tab1':
        document.title = 'ISTAM';
        break;
      case 'Tab2':
        document.title = 'Bulletin Academique';
        break;
      case 'Tab3':
        document.title = 'Reçu de Paiement';
        break;
      case 'Tab4':
        document.title = 'Upload Documents';
        break;
        case 'Tab5':
          document.title = 'Recherche de Document';
          break;
      default:
        document.title = 'Admin';
    }
  }, [activeTab]);

  const enter = () => {
    navigate('/gen')
}
  return (
    <div className="ISTAM">
      <div className="tab-page">
        <Nav/>
        <br/>
        <br/>
        <div className="tab-container">
          <div className="tabs">
            <button
              className={activeTab === 'Tab1' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab1')}
            >
              Carte Etudiant
            </button>
            <button
              className={activeTab === 'Tab2' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab2')}
            >
              Bulletin Academique
            </button>
            <button
              className={activeTab === 'Tab3' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab3')}
            >
              Reçu de Paiement
            </button>
            <button
              className={activeTab === 'Tab4' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab4')}
            >
              Upload Documents
            </button>
            <button
              className={activeTab === 'Tab5' ? 'tab active' : 'tab'}
              onClick={() => setActiveTab('Tab5')}
            >
              Recherche de Document
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 'Tab1' && <div className="content"><Card/></div>}
            {activeTab === 'Tab2' && <div className="content"><Transcript/></div>}
            {activeTab === 'Tab3' && <div className="content"><Receipt/></div>}
            {activeTab === 'Tab4' && <div className="content"><UploaDoc/></div>}
            {activeTab === 'Tab5' && <div className="content"><SearchDoc/></div>}
          </div>
        </div>
        <footer>G.A.P 2025 © All Rights Reserved.</footer>
      </div>
    </div>
  );
}

export default Tab;
